import RestuarantImg from "../../assests/images/dashboard/default-thumbnail (1).jpg";
import DeleteIcon from "../../assests/images/dashboard/delete.png";
import RetingImg from "../../assests/images/dashboard/kid_star.png";
import CardImg from "../../assests/images/dashboard/map.png";
import GroupImg from "../../assests/images/dashboard/group.png";
import { FRONTEND_URL } from "src/constants/endpoints";
import { restaurantSegment } from "src/utils/restaurantUrl";
import { S3_BASE_URL } from "src/constants/endpoints";



const RestaurantCard = ({ restaurant, isDashboard, handleRestaurantClick }: any) => {

  const changeModeToRestaurant = () => {
    localStorage.setItem("restaurant", JSON.stringify(restaurant));
    window.location.href = `${FRONTEND_URL}/restaurants/${restaurantSegment(restaurant.correlationId, restaurant.name)}/orders`;
  };
  const address = `${restaurant?.address?.addressLine1 || "--"}, ${
    restaurant?.address?.addressLine2
      ? restaurant?.address?.addressLine2 + ", "
      : ""
  }${restaurant?.address?.city}, ${restaurant?.address?.state}, ${
    restaurant?.address?.zipCode
  }`;
  
  return (
    <div
      key={restaurant.correlationId}
      className={`relative w-full max-w-[448px] ${!isDashboard ? 'm-auto' : ''} h-[305px] border-[#F1F1F2] border bg-white rounded-xl overflow-hidden`}
    >
      <div>
        <img
          className="h-[173px] w-[100%] object-cover rounded-t-xl cursor-pointer"
          src={restaurant?.bucketKeyName ? restaurant?.bucketKeyName.includes('blob') ? restaurant?.bucketKeyName : S3_BASE_URL + restaurant?.bucketKeyName : RestuarantImg }
          alt={restaurant.name}
          onClick={changeModeToRestaurant}
        />
      </div>
      <div className="absolute right-2 top-2 flex items-center gap-2">
        {restaurant.storeStaffRole && (
          <span className="px-2 py-1 rounded-md text-xs font-medium bg-slate-100 text-slate-600">
            {restaurant.storeStaffRole === "OWNER" ? "Owner" : "Manager"}
          </span>
        )}
        {restaurant.storeStaffRole === "OWNER" && (
          <div
            className="h-[42px] w-[42px] rounded-xl bg-[#FEF5F4] flex justify-center items-center cursor-pointer"
            onClick={() => handleRestaurantClick(restaurant.correlationId)}
          >
            <img className="w-[12px] h-[13px]" src={DeleteIcon} alt="" />
          </div>
        )}
      </div>

      <div className="h-[132px] p-4 flex flex-col">
        <div className="flex justify-between gap-3 min-h-[48px]">
          <h1
            className="min-w-0 text-[20px] leading-6 font-medium overflow-hidden [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]"
            title={restaurant.name}
          >
            {restaurant.name}
          </h1>
          <div className="flex shrink-0 items-center gap-1 self-start pt-1">
            <img className="w-[15px] h-[14px]" src={RetingImg} alt="Rating" />
            <span>{restaurant.averageRating || "0.0"}</span>
            <span className="text-xs text-[#666666]">({restaurant.numberOfReviews || "0" })</span>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-1 min-w-0">
          <img className="w-[15px] h-[15px] shrink-0" src={CardImg} alt="Card" />
          <div className="tooltip min-w-0">
            <p className="tooltip-section text-[#666666] text-sm truncate">
              {address}
            </p>
            <span className="tooltip-text">{address}</span>
          </div>
        </div>

        <div className="flex items-center gap-1 mt-auto">
          <img className="w-[19px] h-[14px] shrink-0" src={GroupImg} alt="Group" />
          <p className="text-[#666666] text-sm">
            {restaurant?.employeeCount || 0} Employees
          </p>
        </div>
      </div>
    </div>
  );
};

export default RestaurantCard;
